'use strict';

var network = require('./network.js');

class BadRequestError extends network.NetworkError {
}

exports.BadRequestError = BadRequestError;
//# sourceMappingURL=bad_request.js.map
